import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { environment } from 'environments/environment';
import { catchError, map } from 'rxjs';

export interface ProcessingJobStatusSummary {
  uploaded: number;
  processing: number;
  pendingReview: number;
  reviewed: number;
  processed: number;
  error: number;
}

@Injectable({
  providedIn: 'root'
})
export class ProcessingJobsService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) { }

  findById(id: string, query = '') {
    return this.http
      .get(`${environment.API_URL}/analytics/processing-jobs/${id}${query}`, { observe: 'response' })
      .pipe(
        map(response => response),
        catchError((error) => { this.errorService.handleError(error); throw error; })
      );
  }

  getStatusSummary(projectId: string) {
    return this.http
      .get<ProcessingJobStatusSummary>(
        `${environment.API_URL}/analytics/processing-jobs/status-summary?project=${projectId}`,
        { observe: 'response' }
      )
      .pipe(
        map(response => response),
        catchError((error) => { this.errorService.handleError(error); throw error; })
      );
  }
}

